import axios from "axios";
import { cnxAPI, notifica, show_ldr, getIdUsuario } from "./utils";

var a = null;

function getParams(IdRepor, _callback) {
  show_ldr(true);
  try {
    axios({
      method: "post",
      url: cnxAPI + "Report/GetParams",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "X-Requested-With": "XMLHttpRequest",
      },
      data: { IdUsuarioAct: getIdUsuario(), IdVista: IdRepor },
    })
      .then(function (response) {
        show_ldr(false);
        if (response.status !== 200) {
          notifica("warning", response.data.message, "Alerta!");
        } else {
          a = response.data;
        }
      })
      .catch(function (error) {
        show_ldr(false);
        notifica("danger", error, "Error");
      })
      .then(() => _callback(a));
  } catch (err) {
    console.log(err);
  }
}

export { getParams };
